import {
  GET_USERS_FAILED,
  GET_USERS_REQUEST,
  GET_USERS_SUCCESS,
  GET_USER_CHECKLIST_SUCCESS,
  GET_USER_VIEWS_SUCCESS,
  INVITE_USER,
  INVITE_USERS_FAILED,
  INVITE_USERS_REQUEST,
  INVITE_USERS_SUCCESS,
  LOGOUT,
  ORDER_USER_VIEWS_SUCCESS,
  SET_USER_CHECKLIST_SUCCESS,
} from 'actions';
import { ViewType } from 'enums/view';
import update from 'immutability-helper';

import createReducer from './createReducer';

// TODO - key Checklist with ChecklistAction enum

export interface Checklist {
  setupScoring?: boolean;
  connectEmail?: boolean;
  addContactBulk?: boolean;
  addConnectwise?: boolean;
  managerInviteColleagues?: boolean;
  setupCustomData?: boolean;
  setupPortfolios?: boolean;
  analysePortfolio?: boolean;
  addTeams?: boolean;
  reviewYourActivity?: boolean;
  setupAccount?: boolean;
  integrateOffice365?: boolean;
  createFirstSegment?: boolean;
  addContactSuggested?: boolean;
  useCustomData?: boolean;
  downloadApp?: boolean;
  addTeamsCalling?: boolean;
  welcomeProductTour?: boolean;
  addReminder?: boolean;
  analyseSegment?: boolean;
  addOutlook?: boolean;
  addNote?: boolean;
  inviteColleagues?: boolean;
}

export interface Views {
  [ViewType.COMPANY]: string[];
  [ViewType.CONTACT]: string[];
  [ViewType.PORTFOLIO]: string[];
  [ViewType.TABS]: string[];
}

interface UserState {
  loading: boolean;
  loaded: boolean;
  checklist: Checklist;
  views: null | Views;
}

const INITIAL_STATE: UserState = {
  loading: false,
  loaded: false,
  checklist: {},
  views: null,
};

type DataAction = {
  type: string;
  data?: Checklist;
};

type ViewsAction = {
  type: string;
  data?: Views;
};

type KeyValueAction = {
  type: string;
  data?: { key: string; value: boolean };
};

export default createReducer(INITIAL_STATE, {
  [INVITE_USER]: (state) => ({ ...state }),
  [GET_USERS_REQUEST]: (state) => ({ ...state, loading: true }),
  [GET_USERS_SUCCESS]: (state) => ({ ...state, loading: false, loaded: true }),
  [GET_USERS_FAILED]: (state) => ({ ...state, loading: false }),
  [GET_USER_CHECKLIST_SUCCESS]: (state, action?: DataAction) => {
    const data = action?.data;
    if (data === undefined) {
      return state;
    }
    return update(state, {
      checklist: {
        $set: data,
      },
    });
  },
  [SET_USER_CHECKLIST_SUCCESS]: (state, action?: KeyValueAction) => {
    const data = action?.data;
    if (data === undefined) {
      return state;
    }
    return update(state, {
      checklist: {
        $merge: { [data.key]: data.value },
      },
    });
  },
  [GET_USER_VIEWS_SUCCESS]: (state, action?: ViewsAction) => {
    const data = action?.data;
    if (data === undefined) {
      return state;
    }
    return update(state, {
      views: {
        $set: data,
      },
    });
  },
  [ORDER_USER_VIEWS_SUCCESS]: (state, action?: ViewsAction) => {
    const data = action?.data;
    if (data === undefined) {
      return state;
    }
    return update(state, {
      views: {
        $set: data,
      },
    });
  },
  [INVITE_USERS_REQUEST]: (state) => ({ ...state, loading: true }),
  [INVITE_USERS_SUCCESS]: (state) => ({ ...state, loading: false }),
  [INVITE_USERS_FAILED]: (state) => ({ ...state, loading: false }),
  [LOGOUT]: () => ({ ...INITIAL_STATE }),
});
